import { v7 as uuidv7 } from 'uuid';

export function getGuid() {
  var id = uuidv7();
  return id;
}

/**
 * 获取随机id
 */
export function getGuid2() {
  var id = guid();
  /*获取id*/
  function guid() {
    return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  // console.log(id, 'id');
  return id;
}

/**
 * 获取随机数
 */
export function getRandom() {
  let ccode = '' as any;
  for(let i=0;i<6;i++){
    ccode += Math.floor(Math.random()*10);
  }
  return ccode;
}

